<!-- <template>
  <h1>Hello From Approved component</h1>
</template>

<script>
// import { BOverlay, BCard, BBreadcrumb, BBreadcrumbItem } from "bootstrap-vue";
// import { ref, reactive } from "@vue/composition-api";
</script>

<style>
</style> -->
<template>
  <div>
    <!-- Table Container Card -->
    <!-- <BulksModal user-type="driver" /> -->
    <b-card
      no-body
      class="mb-0"
    >
      <div class="m-2">
        <b-row>
          <b-col
            cols="12"
            md="9"
          >
            <b-row>
              <b-col md="12">
                <b-input-group>
                  <b-form-input
                    placeholder="external id"
                    @keypress.enter="applyQuickSerach"
                    @input="(val) => (searchQuery.driverExternalId = val)"
                  />
                  <b-form-input
                    placeholder="added by"
                    @keypress.enter="applyQuickSerach"
                    @input="(val) => (searchQuery.addedBy = val)"
                  />
                  <b-input-group-append>
                    <b-button
                      variant="outline-primary"
                      @click="applyQuickSerach"
                    >
                      Search
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-col>
              <b-col md="12" />
            </b-row>
          </b-col>
          <b-col
            cols="6"
            class="mt-2 mt-md-0 d-flex justify-content-center"
            md="2"
          />
          <b-col :class="`d-flex ${$can('read', 'drivers-license') ? 'justify-content-center' : 'justify-content-end'} align-items-center`">
            <h6>Total: {{ totalPayouts }}</h6>
          </b-col>
        </b-row>
      </div>

      <b-overlay
        variant="white"
        spinner-variant="primary"
        blur="0"
        opacity=".75"
        rounded="sm"
        :show="loadingPayouts"
      >
        <b-table
          ref="refPayoutListTable"
          class="position-relative text-center"
          :items="payouts"
          responsive
          :fields="tableColumns"
          primary-key="id"
          :sort-by.sync="sortBy"
          show-empty
          empty-text="No matching payouts found"
          :sort-desc.sync="isSortDirDesc"
          :style="totalPayouts === 1 ? 'height :150px' : 'height: auto'"
        >
          <!-- Column: Driver -->
          <template #cell(driver_external_id)="data">
            <b-media vertical-align="center">
              <b-link
                v-if="data.item.driver_id"
                :to="{
                  name: 'drivers-view',
                  params: { id: data.item.driver_id },
                  query: { externalId: data.item.driver_external_id },
                }"
                class="font-weight-bold d-block text-nowrap"
                target="_blank"
              >
                {{ data.item.driver_external_id }}
              </b-link>
              <span v-else>
                {{ data.item.driver_external_id }}
              </span>
            </b-media>
          </template>

          <!-- Column: Vendor -->
          <template #cell(payout_wallet)="data">
            <b-media
              v-if="data.item.payout_wallet.vendor"
              vertical-align="center"
            >

              <span v-if="data.item.payout_wallet.vendor === 'IBAN'">
                {{ data.item.payout_wallet.meta.IBAN }}
              </span>
              <span v-else-if="data.item.payout_wallet.meta.phoneNumber">
                {{ data.item.payout_wallet.meta.phoneNumber }}
              </span>
            </b-media>
          </template>

          <!-- Column: State -->
          <template #cell(state)="data">
            <b-badge
              v-if="data.item.state"
              pill
              variant="light-success"
              class="text-capitalize"
            >{{ data.item.state }}
            </b-badge>
          </template>

          <!-- Column: Actions -->
          <template #cell(actions)="data">
            <b-dropdown
              variant="link"
              no-caret
              :right="$store.state.appConfig.isRTL"
            >
              <template #button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="align-middle text-body"
                />
              </template>
              <b-dropdown-item
                v-if="$can('write', 'payout-actions-basics') || $can('write', 'payout-actions-pay')"
                @click="payoutTransition(data.item.id, 'approve')"
              >
                <feather-icon
                  icon="CheckCircleIcon"
                  class="text-success"
                />
                <span class="align-middle ml-50 text-success">approve</span>
              </b-dropdown-item>
              <b-dropdown-item
                v-if="$can('write', 'payout-actions-basics') || $can('write', 'payout-actions-pay')"
                @click="payoutTransition(data.item.id, 'decline')"
              >
                <feather-icon
                  icon="StopCircleIcon"
                  class="text-danger"
                />
                <span class="align-middle ml-50 text-danger">decline</span>
              </b-dropdown-item>
            </b-dropdown>
          </template>

        </b-table>
      </b-overlay>
      <div class="mx-2 mb-2">
        <b-row>
          <!-- Per Page -->
          <b-col
            cols="8"
            md="6"
            lg="6"
          >
            <div
              class="d-flex align-items-center align-items-lg-center  mb-1 mb-md-0"
            >
              <label>Show</label>
              <v-select
                v-model="perPage"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="perPageOptions"
                :clearable="false"
                class="per-page-selector d-inline-block mx-sm-1"
              />
              <label>entries</label>
            </div>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >
            <b-pagination
              v-model="currentPage"
              :total-rows="totalPayouts"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  // BFormGroup,
  BButton,
  BTable,
  BMedia,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BInputGroupAppend,
  BInputGroup,
  BOverlay,
  // BForm,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
// import usePayoutsList from '../hooks/usePayoutsLists'
import {
  onUnmounted, ref, watch, computed,
} from '@vue/composition-api'
import { convertToLocaleAndFormatDate } from '@/utils/date-format'
import { errorNotification, successNotification } from '@/utils/toast-notifications'
import reFetchAPI from '@/utils/refetch-api'
import payoutStoreModule from '../payoutStoreModule'

// import { avatarText } from '@core/utils/filter'
import store from '@/store'
// import CardCollapse from '@/UI/CardCollapse.vue'

export default {
  components: {
    // CardCollapse,
    BCard,
    BRow,
    BCol,
    // BForm,
    BFormInput,
    // BFormGroup,
    BButton,
    BTable,
    BMedia,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BInputGroupAppend,
    BInputGroup,
    BOverlay,
    vSelect,
  },
  props: { },
  methods: { },
  setup(props, ctx) {
    const PAYOUT_APP_STORE_MODULE_NAME = 'payouts'

    if (!store.hasModule(PAYOUT_APP_STORE_MODULE_NAME)) { store.registerModule(PAYOUT_APP_STORE_MODULE_NAME, payoutStoreModule) }

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(PAYOUT_APP_STORE_MODULE_NAME)) { store.unregisterModule(PAYOUT_APP_STORE_MODULE_NAME) }
    })

    console.log('props', props)
    console.log('ctx', ctx)
    const refPayoutListTable = ref(null)
    const tableColumns = [
      {
        key: 'driver_external_id',
        label: 'Driver External ID',
        formatter: value => value || '_',
      },
      { key: 'payout_wallet.vendor', label: 'vendor' },
      { key: 'payout_wallet', label: 'vendor number' },
      { key: 'state' },
      { key: 'added_by' },
      { key: 'amount' },
      { key: 'created_at', formatter: value => convertToLocaleAndFormatDate(value) },
      // { key: 'updated_at', formatter: value => value },
      { key: 'Actions' },
    ]

    const perPage = ref(10)
    const totalPayouts = ref(0)
    const currentPage = ref(1)

    const perPageOptions = [2, 10, 25]
    const searchQuery = ref({
      state: 'pending',
    })
    const sortBy = ref('id')
    const isSortDirDesc = ref(false)
    const payouts = ref([])
    const loadingPayouts = ref(false)

    const quickFilterApplied = ref(false)
    const advancedFilterApplied = ref(false)

    const dataMeta = computed(() => {
      const localItemsCount = refPayoutListTable.value ? refPayoutListTable.value.localItems.length : 0
      return {
        from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
        to: perPage.value * (currentPage.value - 1) + localItemsCount,
        of: totalPayouts.value,
      }
    })
    const fetchPayouts = async () => {
      loadingPayouts.value = true
      const requestSearchQuery = { ...searchQuery.value }
      Object.keys(requestSearchQuery).forEach(key => {
        if (!requestSearchQuery[key]) delete requestSearchQuery[key]
      })
      try {
        const response = await store
          .dispatch('payouts/fetchPayouts', {
            ...requestSearchQuery,
            sortDesc: isSortDirDesc.value,
            size: perPage.value,
            page: currentPage.value,
          })
        loadingPayouts.value = false
        payouts.value = response.payouts
        totalPayouts.value = response.total
      } catch (error) {
        if (error.message.includes('timeout')) {
          fetchPayouts()
        } else {
          reFetchAPI(fetchPayouts)
        }
      }
      loadingPayouts.value = false
    }
    const payoutTransition = async (payoutId, action) => {
      try {
        await store.dispatch('payouts/payoutTransition', { payoutId, action })
        successNotification('Payout transitioned successfully')
        fetchPayouts()
      } catch (error) {
        errorNotification(error.message)
      }
    }
    watch([currentPage, perPage], () => {
      fetchPayouts()
    })
    const applyQuickSerach = () => {
      quickFilterApplied.value = true
      advancedFilterApplied.value = false
      fetchPayouts()
    }
    fetchPayouts()

    return {
      tableColumns,
      payouts,
      totalPayouts,
      perPage,
      currentPage,
      searchQuery,
      sortBy,
      isSortDirDesc,
      loadingPayouts,
      quickFilterApplied,
      advancedFilterApplied,
      dataMeta,
      fetchPayouts,
      payoutTransition,
      refPayoutListTable,
      applyQuickSerach,
      perPageOptions,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
::v-deep .list-inline svg {
  color: #d84e71;
  width: 2rem !important;
  height: 2rem !important;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-sweetalert.scss";
</style>
